import React from 'react'
import styled from 'styled-components'
import Button from 'core-system/Button'
import Modal, { ModalBody, ModalFooter, ModalHeader } from 'core-system/Modal'
import Text from 'core-system/Text'
import palette from 'core-system/Themes/palette'
import { TransitAgency } from 'redux/transitPass/transitPassTypes'

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

const AddressBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  background-color: ${palette.secondary.purple100};
`

const FooterActions = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`

interface RequestTransitPassModalProps {
  open: boolean
  agency: TransitAgency
  shippingAddress?: string | null
  onClose: () => void
}

const RequestTransitPassModal = React.memo(
  ({
    open,
    agency,
    shippingAddress = null,
    onClose,
  }: RequestTransitPassModalProps) => {
    return (
      <Modal open={open} onClose={onClose} width='28rem'>
        <ModalHeader title='Request Submitted' onClose={onClose} />
        <ModalBody>
          <Content>
            <Text variant='body1' textColor={palette.text.secondary}>
              Thank you for your request. Your {agency.name} card will arrive at
              the following address in 5–10 days.
            </Text>
            <AddressBlock>
              <Text variant='action4' textColor={palette.text.placeholder}>
                Shipping Address
              </Text>
              <Text variant='action2'>
                {shippingAddress || 'Address unavailable'}
              </Text>
            </AddressBlock>
          </Content>
        </ModalBody>
        <ModalFooter>
          <FooterActions>
            <Button onClick={onClose}>Done</Button>
          </FooterActions>
        </ModalFooter>
      </Modal>
    )
  }
)

RequestTransitPassModal.displayName = 'RequestTransitPassModal'

export default RequestTransitPassModal
